import { SubtitleCue } from "@core/utils/subtitles/types";
import appEvents from "@core/events/events";
import { useEffect, useState } from "react";
import { Fade } from "@core/components/Transitions/Fade";

/**
 * SubtitleOverlay component
 * Displays subtitles based on subtitle-cue events from ContentPlaybackController
 */
export const SubtitleOverlay = () => {
  const [currentCue, setCurrentCue] = useState<SubtitleCue | null>(null);

  useEffect(() => {
    const handleSubtitleCue = (cue: SubtitleCue | null) => {
      setCurrentCue(cue);
    };

    appEvents.on("subtitle-cue", handleSubtitleCue);
    
    return () => {
      appEvents.off("subtitle-cue", handleSubtitleCue);
    };
  }, []);

  if (!currentCue) {
    return null;
  }

  return (
    <Fade visible={!!currentCue}>
      <div className="fixed bottom-20 left-0 right-0 z-50 pointer-events-none select-none touch-none [-webkit-touch-callout:none] [-webkit-tap-highlight-color:transparent] flex justify-center pb-8 px-4">
        <div className="bg-black/70 backdrop-blur-sm rounded-lg px-6 py-4 max-w-4xl">
          <p className="text-white text-center text-lg md:text-xl font-medium leading-relaxed">
            {currentCue.text}
          </p>
        </div>
      </div>
    </Fade>
  );
};

